import React from 'react'

import { ItemCardVariant } from './ItemCard'
import ItineraryItemCard from './ItineraryItemCard'

import { CarRentalItem } from 'tripPlanner/types/tripItem'
import { formatShortDateRange } from 'tripPlanner/utils'

interface Props {
  item: CarRentalItem
  onClickTripName?: () => void
  variant: ItemCardVariant
}

function CarRentalItemCard({ item, onClickTripName, variant }: Props) {
  const {
    companyName,
    carType,
    startPlace,
    startDate,
    endDate,
    startDay,
    endDay,
    confirmationCode,
  } = item

  const placeId = 'id' in startPlace ? startPlace.id : undefined
  const timeDescription = formatShortDateRange({
    startDate,
    endDate,
    startDay,
    endDay,
  })
  return (
    <ItineraryItemCard
      item={item}
      name={carType ?? startPlace.name}
      locationDescription={startPlace.region}
      placeId={placeId}
      descriptors={[timeDescription, companyName]}
      printDescriptors={[timeDescription, companyName]}
      address={startPlace.address}
      confirmationCode={confirmationCode}
      onClickTripName={onClickTripName}
      variant={variant}
      isPlaceRatingsVisible={false}
    />
  )
}

export default CarRentalItemCard
